module.exports = __webpack_public_path__ + "static/media/undraw_Chatting_re_j55r 1.b4f78395.svg";